/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ExclusionTerm } from './ExclusionTerm';
import {
    ExclusionTermFromJSON,
    ExclusionTermFromJSONTyped,
    ExclusionTermToJSON,
} from './ExclusionTerm';

/**
 * 
 * @export
 * @interface GetDocumentExclusionTerms200Response
 */
export interface GetDocumentExclusionTerms200Response {
    /**
     * 
     * @type {Array<ExclusionTerm>}
     * @memberof GetDocumentExclusionTerms200Response
     */
    data?: Array<ExclusionTerm>;
}

/**
 * Check if a given object implements the GetDocumentExclusionTerms200Response interface.
 */
export function instanceOfGetDocumentExclusionTerms200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function GetDocumentExclusionTerms200ResponseFromJSON(json: any): GetDocumentExclusionTerms200Response {
    return GetDocumentExclusionTerms200ResponseFromJSONTyped(json, false);
}

export function GetDocumentExclusionTerms200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetDocumentExclusionTerms200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(ExclusionTermFromJSON)),
    };
}

export function GetDocumentExclusionTerms200ResponseToJSON(value?: GetDocumentExclusionTerms200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(ExclusionTermToJSON)),
    };
}

